if (!window.Eurus.loadedScript.has('bundle-components.js')) {
  window.Eurus.loadedScript.add('bundle-components.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      const QUERY = `query BundleComponents($handle: String!) {
        product(handle: $handle) {
          variants(first: 25) {
            nodes {
              id
              requiresComponents
              components(first: 30) {
                nodes {
                  quantity
                  productVariant {
                    id
                    title
                    availableForSale
                    image { url altText }
                    price { amount currencyCode }
                    product {
                      title
                      handle
                      variantsCount { count }
                      featuredImage { url altText }
                    }
                  }
                }
              }
            }
          }
        }
      }`;

      Alpine.data('xBundleComponents', () => ({
        loading: false,
        loaded: false,
        items: [],
        // Componentes indexados por id de variante del bundle padre: un kit puede
        // venderse en varios tamaños y llevar componentes distintos en cada uno
        // (p. ej. Kit Linea Le Coccole → 115 ml / 50 ml).
        byVariant: {},

        init() {
          const sectionId = this.$root.dataset.sectionId;
          if (!sectionId) return;

          // El theme reemite la sección renderizada al cambiar de variante.
          document.addEventListener(`eurus:product-page-variant-select:updated:${sectionId}`, (e) => {
            this.selectVariant(this.readVariantId(e.detail && e.detail.html, sectionId));
          });
        },

        async load() {
          if (this.loading || this.loaded) return;
          this.loading = true;

          // $root (no $el) para que la config se lea siempre del elemento con x-data.
          const data = this.$root.dataset;

          try {
            const response = await fetch(`/api/${data.apiVersion}/graphql.json`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-Shopify-Storefront-Access-Token': data.token,
              },
              body: JSON.stringify({ query: QUERY, variables: { handle: data.handle } }),
            });

            const json = await response.json();
            const variants = json?.data?.product?.variants?.nodes || [];

            // Una sola petición cubre todas las variantes del padre: cambiar de
            // variante después solo reindexa, no vuelve a la red.
            const byVariant = {};
            variants.forEach((variant) => {
              if (!variant.requiresComponents) return;
              byVariant[this.variantId(variant.id)] = (variant.components?.nodes || []).map((node) =>
                this.mapComponent(node, data)
              );
            });

            this.byVariant = byVariant;
            this.selectVariant(data.variantId);
          } catch (e) {
            // Un fallo de red no debe romper la ficha: el bloque simplemente no aparece.
            this.byVariant = {};
            this.items = [];
          }

          this.loading = false;
          this.loaded = true;
        },

        selectVariant(variantId) {
          // Sin entrada en el índice, esa variante no es un bundle: no se muestra nada.
          this.items = this.byVariant[String(variantId)] || [];
        },

        readVariantId(html, sectionId) {
          const fromRender = html?.getElementById?.(`update-variant-${sectionId}`)?.value;
          if (fromRender) return fromRender;

          const fromDom = document.getElementById(`update-variant-${sectionId}`)?.value;
          if (fromDom) return fromDom;

          return new URLSearchParams(window.location.search).get('variant') || '';
        },

        mapComponent(node, data) {
          const variant = node.productVariant;
          const image = variant.image || variant.product.featuredImage;

          return {
            quantity: node.quantity,
            title: variant.product.title,
            variantTitle: this.variantLabel(variant.title),
            available: variant.availableForSale,
            url: this.productUrl(variant, data.rootUrl),
            imageUrl: this.imageUrl(image),
            imageAlt: (image && image.altText) || variant.product.title,
            price: this.money(variant.price, data.moneyFormat),
          };
        },

        variantId(gid) {
          return String(gid).split('/').pop();
        },

        // "Default Title" es el nombre que Shopify da a la variante única: no aporta nada.
        variantLabel(title) {
          return !title || title.toLowerCase() === 'default title' ? '' : title;
        },

        // El bundle apunta a UNA variante concreta del componente (p. ej. la de 30 ml),
        // que no tiene por qué ser la que el producto muestra por defecto. Si el producto
        // tiene más de una variante hay que enlazar a la del kit, no a la primera.
        productUrl(variant, rootUrl) {
          const root = rootUrl && rootUrl !== '/' ? rootUrl.replace(/\/$/, '') : '';
          const url = `${root}/products/${variant.product.handle}`;
          const count = variant.product.variantsCount?.count || 1;
          return count > 1 ? `${url}?variant=${this.variantId(variant.id)}` : url;
        },

        imageUrl(image) {
          if (!image || !image.url) return '';
          return `${image.url}${image.url.includes('?') ? '&' : '?'}width=240`;
        },

        money(price, format) {
          if (!price || !format) return '';
          const cents = Math.round(parseFloat(price.amount) * 100);
          return Alpine.store('xHelper').formatMoney(cents, format);
        },
      }));
    });
  });
}
